/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
// import Button from '@mui/material/Button';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function InactivityDialog({
  open,
  setOpen,
  timer,
  resetTimeout,
  logout,
}) {
  const handleClose = () => {
    setOpen(false);
    resetTimeout();
  };

  useEffect(() => {
    if (timer === 0) {
      logout();
      window.location.reload(true);
    }
  }, [timer]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Logout in {timer} secs
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You will be logged out due to inactivity. Click continue to remain
            signed in.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
